let loading = false;

/**
 *
 * @param url
 * @param name
 * @param callback
 * @return {Promise<any>}
 */
export function loadScript(url, name, callback = null) {
    const result = new Promise(function (resolve, reject) {
        if (window[name]) {
            resolve(window[name]);
        } else if (loading) {
            let interval = setInterval(function () {
                if (window[name]) {
                    interval && clearInterval(interval);

                    loading = false;
                    resolve(window[name]);
                }
            }, 10);
        } else {
            loading = false;

            createScript(url, resolve, reject);
        }
    });

    if (callback) {
        result.then(callback);
    }

    return result;
}

/**
 *
 * @param scripts
 * @param callback
 */
export function loadScripts(scripts, callback = null) {
    const promises = Object.keys(scripts).map((key) => loadScript(scripts[key], key));

    Promise.all(promises).then(callback);
}

export function loadStyle(url, name, callback = null) {
    const result = new Promise(function (resolve, reject) {
        if (window[name]) {
            resolve(window[name]);
        } else if (loading) {
            let interval = setInterval(function () {
                if (window[name]) {
                    interval && clearInterval(interval);

                    loading = false;
                    resolve(window[name]);
                }
            }, 10);
        } else {
            loading = false;

            createStyle(url, resolve, reject);
        }
    });

    if (callback) {
        result.then(callback);
    }

    return result;
}

/**
 *
 * @param scripts
 * @param callback
 */
export function loadStyles(scripts, callback = null) {
    const promises = Object.keys(scripts).map((key) => loadStyle(scripts[key], key));

    Promise.all(promises).then(callback);
}

/**
 * @param url
 * @param successCallback
 * @param errorCallback
 */
export function  createScript(url, successCallback, errorCallback) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

    addEventHandler(script, 'readystatechange', successCallback);
    addEventHandler(script, 'load', successCallback);
    addEventHandler(script, 'error', errorCallback);

    document.body.appendChild(script);
}

/**
 * @param url
 * @param successCallback
 * @param errorCallback
 */
export function createStyle(url, successCallback, errorCallback) {
    const style = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = url;
    style.crossorigin = "";

    addEventHandler(style, 'readystatechange', successCallback);
    addEventHandler(style, 'load', successCallback);
    addEventHandler(style, 'error', errorCallback);

    document.head.appendChild(style);
}

/**
 * Add event handler to the given element
 * @param {Object} element
 * @param {String} eventType
 * @param {Function} handler
 */
function addEventHandler(element, eventType, handler) {
    if (element.addEventListener) {
        element.addEventListener(eventType, handler, false);
    } else if (element.attachEvent) {
        element.attachEvent('on' + eventType, handler);
    }
}
